<pdq-rules-dynamic-form
  [formGroup]="formGroup"
  [formArrayFieldName]="formArrayFieldName"
  [rules]="blackoutDatesRules"
  [entities]="entities"
  [shop]="shop"></pdq-rules-dynamic-form>
